<div class="counter" fxLayout="row">
    <div>
        <button mat-icon-button (click)="decrementCount()">
            <mat-icon svgIcon="ic-minus"></mat-icon>
        </button>
    </div>
    <span class="counter-display">{{displayCount}}</span>
    <div>
        <button mat-icon-button (click)="incrementCount()">
            <mat-icon svgIcon="ic-plus"></mat-icon>
        </button>
    </div>

</div>
